import {
    FETCH_IS_LOADING,
    SET_HAS_ERROR,
    SET_NOTIFICATION,
    UNSET_NOTIFICATION
} from "../actions/modeAction";
const initialState = {
    hasError: false,
    isLoading: true,
    maintenance: false,
    notification: {
        type: null,
        message: null,
    }
    ,
};
const modeReducer = (state = initialState, action) => {

    switch (action.type) {
        case FETCH_IS_LOADING: {
            return {
                ...state,
                isLoading: action.payload
            }
        }
        case SET_HAS_ERROR: {
            return {
                ...state,
                hasError: true
            }
        }
        case SET_NOTIFICATION: {
            const { type, message } = action.payload;
            return {
                ...state,
                notification: {
                    type: type,
                    message: message,
                }
            }
        }
        case UNSET_NOTIFICATION: {
            return {
                ...state,
                notification: initialState.notification
            }
        }
        default:
            return state;
    }
};
export default modeReducer;
